<script lang="ts">
	import { beforeUpdate, createEventDispatcher, onMount, getContext } from 'svelte';
	import { Text, Input, Button } from '@Shelly/shelly-design-system';
	import { rooms } from 'src/stores/lists/rooms';

	import ImageList from '../ImageList.svelte';
	import { format } from '../../../services/i18n';
	import { requestSaveRoom, getImagesByType, getImages } from '../list-helpers';
	import { createAsyncAction } from 'src/helpers/async_action_guard';

	const requestType = 'room';
	const dispatch = createEventDispatcher();
	const { loading: isSaving, run: runSave } = createAsyncAction();

	let newRoomStore: SvelteStore<any> = getContext('newRoomStore');

	let editRoom: any = {
		name: undefined,
		image: '',
	};
	let currentRoute = '';
	let uploadedImagesDB = [];
	let imagesByRoomType = [];

	export let type = 'rooms';

	$: items = [...Object.values($rooms)];
	$: disabled = editRoom?.name?.trim() === '' || typeof editRoom.name === 'undefined';

	const onInputName = (event: InputEvent) => {
		const target = event.target as HTMLInputElement;
		editRoom = {
			...editRoom,
			name: target.value,
		};
	};

	const validateRoomName = (room) => {
		const isEmpty = room.name === '';

		return {
			isValid: !isEmpty,
		};
	};

	const handleAddEditRoomFinish = () =>
		runSave(async () => {
			editRoom.name = editRoom.name.trim();

			let currentEditRoom = {
				...editRoom,
			};

			// new Room data
			currentEditRoom = {
				...editRoom,
				main_sensor: false,
				overview_style: false,
				position:
					typeof items.length !== 'undefined' && items.length > 0
						? items[items.length - 1]['position'] + 1
						: 0,
				//covering create new room when no rooms during inclusion
			};

			if (!validateRoomName(currentEditRoom).isValid) {
				return;
			}

			await requestSaveRoom(currentEditRoom, false);

			dispatch('after-room-update');
			$newRoomStore = {
				newRoom: currentEditRoom,
				newRoomEditing: false,
			};
		});

	const closeCreateNewRoom = () => {
		$newRoomStore = {
			newRoom: undefined,
			newRoomEditing: false,
		};
	};

	// Image List Functions
	const onSelectImage = (e: CustomEvent) => {
		editRoom = {
			...editRoom,
			image: e.detail.image,
			backgroundColor: e.detail?.backgroundColor,
		};
	};

	const onUploadImage = (e: CustomEvent) => {
		onSelectImage(e);
		uploadedImagesDB = [...e.detail.uploadedImagesDB];
	};

	beforeUpdate(() => {
		if (imagesByRoomType.length === 0) {
			imagesByRoomType = getImagesByType(requestType, null);
		}
	});

	onMount(async () => {
		uploadedImagesDB = await getImages(requestType);
		currentRoute = type;
	});
</script>

<Text element="h2" class="mb-s">
	{$format('room_name', { default: 'Room Name' })}
</Text>
<Input
	icon="fas fa-door-open"
	class="mb-l"
	id="input-room-name"
	label={$format('label_name', { default: 'name' })}
	aria-label={$format('input_room_name', {
		default: 'Room name',
	})}
	value={editRoom.name}
	error={editRoom.name === ''
		? $format('input_error_empty_name', { default: 'Name cannot be empty' })
		: ''}
	on:input={onInputName}
	on:enter={() => dispatch('enter')}
/>

<Text element="h2" class="mb-l">
	{$format('select_image', { default: 'Select image' })}
</Text>

<ImageList
	{uploadedImagesDB}
	imagesByTypeDB={imagesByRoomType}
	setDefaultImage={Boolean(imagesByRoomType.length > 0)}
	{requestType}
	on:select-image={onSelectImage}
	on:upload-image={onUploadImage}
/>

<div class="d-flex justify-content-end mt-xl">
	<Button
		class="width-md-m width-sm-full mr-m"
		variant="secondary"
		icon="fas fa-chevron-left"
		responsiveSize={{
			sm: 'm',
		}}
		on:click={closeCreateNewRoom}>{$format('button_back')}</Button
	>
	<Button
		{disabled}
		loading={$isSaving}
		class="width-md-m width-sm-full"
		responsiveSize={{
			sm: 'm',
		}}
		icon={'fas fa-save'}
		on:click={handleAddEditRoomFinish}
	>
		{$format('button_save')}
	</Button>
</div>
